<template>
  <div id="nav-head">
    <div class="main-wrap">
      <img src="../../assets/img/top-logo.png" class="logo" @click="jumpWebsite()" alt="" />
      <div class="information">
        <div class="time">System Time：{{ systemTime }}</div>
        <div @click="toHelpDocument" class="helpDocument">Help Documents</div>
        <div class="text">
          <div @click="jumpPage('HomePage')">Hello! {{ userName }}</div>
          <span @click="exitAccount()">Log out</span>
        </div>
        <div class="user-img" @click="jumpPage('HomePage')">
          <img
            v-if="!userImg || userImg === 'default.jpg'"
            src="@/assets/img/default-img.png"
            alt=""
          />
          <img v-else :src="userImg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import './index.less'
import {
  removeToken,
  removeUserType,
  removeUserName,
  removeTeacherInfo,
  getUserName,
  removeUserId,
  getUserId,
  getTeacherInfo,
  getUserImg,
  getFirstSign,
  removeFirstSign,
  getToken
} from '@/utils/teacherAuth'
import { resetRouter } from '@/config/router'
import { mutations } from '@/store'

let open = null
export default {
  mounted() {
    const _this = this
    _this.getTime()
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        //当页面切换或者隐藏时触发的代码，可以用来清除定时器
        clearInterval(_this.timer)
      } else {
        //当页面重新被唤醒时触发的代码，可以用来重新触发定时器
        clearInterval(_this.timer)
        _this.getTime()
      }
    })
    this.getMessage()
  },
  data() {
    return {
      timer: null, //定义一个定时器变量
      time: '',
      systemTime: '',
      userName: null,
      userImg: '',
      ordinaryMsg: {},
      noticeMsg: {},
      notifications: [], // 用于存储当前通知实例
      shownMessages: new Set() // 用于存储已弹出的消息ID，防止重复弹出
    }
  },
  created() {
    this.userName = getUserName()
    this.userImg = getUserImg()
    if (
      window.location.href.indexOf('hongkong.talk915.com') > -1 ||
      window.location.href.indexOf('hk.talk915.com') > -1
    ) {
      window.addEventListener('message', (e) => this.postMessage(e))
    }
    this.$bus.$on('getMessage', () => {
      this.getMessage()
    })
  },
  destroyed() {
    if (
      window.location.href.indexOf('hongkong.talk915.com') > -1 ||
      window.location.href.indexOf('hk.talk915.com') > -1
    ) {
      window.removeEventListener('message', (e) => this.postMessage(e))
    }
    this.$bus.$off('getMessage')
  },
  methods: {
    getMessage() {
      let url = ''
      let api = '/pointServer/pointToPoint/queryLastUnreadMessage'
      if (process.env.NODE_ENV === 'development') {
        url = `https://test.usongshu.com${api}`
      } else {
        url = `${process.env.IM}${api}`
      }
      const params = {
        userId: getUserId(),
        userType: 2,
        platformType: 0
      }
      axios
        .post(url, params)
        .then(({ data }) => {
          const { resultData } = data
          this.ordinaryMsg = resultData.ordinaryMsg
          this.noticeMsg = resultData.noticeMsg
          if (this.ordinaryMsg) {
            // 生成唯一标识符
            const uniqueKey = `${this.ordinaryMsg.userId}-${this.ordinaryMsg.msgBody}-${this.ordinaryMsg.msgSendTime}`
            if (this.shownMessages.has(uniqueKey)) {
              // 如果消息已弹出过，直接返回
              return
            }
            // 将唯一标识符存入 Set
            this.shownMessages.add(uniqueKey)
            let notify = this.$notify({
              title: `${this.ordinaryMsg.userNickName}（${this.ordinaryMsg.userId}）`,
              message: `${
                this.ordinaryMsg.msgType === 1 ? '【图片】' : this.ordinaryMsg.msgBody
              } <br> ${this.ordinaryMsg.msgSendTime}`,
              dangerouslyUseHTMLString: true,
              duration: 0,
              type: 'success',
              onClick: () => {
                let username = getUserName()
                let id = getUserId()
                let url = `${process.env.MESSAGE_LINK}?fromUserId=${id}&fromUserNickName=${username}&fromUserType=2&platformType=0&toUserType=${this.ordinaryMsg.fromUserType}&toUserNickName=${this.ordinaryMsg.userNickName}&toUserIdList=${this.ordinaryMsg.userId}`
                window.open(url, '_blank')
                notify.close()
                setTimeout(() => {
                  this.$bus.$emit('getUnReadNum')
                }, 3000)
              },
              customClass: 'custom-notification'
            })
            // 将新通知添加到数组中
            this.notifications.push(notify)

            setTimeout(() => {
              // 如果通知数量超过 5 条，关闭最早的通知
              if (this.notifications.length > 5) {
                const oldestNotify = this.notifications.shift() // 移除数组中的第一个元素
                oldestNotify.close() // 关闭最早的通知
              }
            }, 500)
          }
          // 说客没有系统公告
          // if (this.noticeMsg) {
          //   this.notify2 = this.$notify({
          //     title: `${this.noticeMsg.noticeTitle}`,
          //     message: `${this.noticeMsg.msgBody} <br> ${this.noticeMsg.msgSendTime}`,
          //     dangerouslyUseHTMLString: true,
          //     duration: 0,
          //     type: 'warning',
          //     onClick: () => {
          //       console.log('notify2')
          //     },
          //     customClass: 'custom-notification'
          //   })
          // }
        })
        .catch((e) => {
          console.log(e, 'IM消息返回报错')
        })
    },
    toHelpDocument() {
      if (
        window.location.href.indexOf('hongkong.talk915.com') > -1 ||
        window.location.href.indexOf('hk.talk915.com') > -1
      ) {
        let domain = window.location.href.indexOf('hongkong.talk915.com') > -1 ? 'hongkong' : 'hk'
        open = window.open(
          `https://www.talk915.com/h5/static/html/helpDocument.html?from=teacher&domain=${domain}`,
          '_blank'
        )
      } else {
        open = window.open(process.env.HELP_DOCUMENT_LINK, '_blank')
      }
    },
    postMessage(e) {
      const msg = {
        token: getToken()
      }
      if (e.origin === 'https://www.talk915.com') {
        open.postMessage(msg, 'https://www.talk915.com')
      }
    },
    jumpPage(routerName) {
      let teacher = JSON.parse(getTeacherInfo())
      if (teacher && teacher.accountStatus === 2 && getFirstSign() == 1) {
        this.$router.push({ name: routerName })
      }
    },
    jumpWebsite() {
      window.location.href = process.env.API_ROOT
    },
    async getTime() {
      const res = await this.$api.getServerTime()
      this.time = res.data.resultData
      this.resTime(this.time)
      this.timer = setInterval(() => {
        this.resTime(this.time)
      }, 1000)
    },
    resTime(time) {
      const comDate = (time) => time.replace(/-/g, '/')
      var myDate =
        time instanceof Object
          ? time
          : typeof time === 'number'
          ? new Date(time)
          : new Date(comDate(time))
      var y = myDate.getFullYear()
      var M = myDate.getMonth() + 1 //获取当前月份(0-11,0代表1月)
      var d = myDate.getDate() //获取当前日(1-31)
      var h = myDate.getHours() //获取当前小时数(0-23)
      var m = myDate.getMinutes() //获取当前分钟数(0-59)
      var s = myDate.getSeconds() //获取当前秒数(0-59)
      M = this.check(M)
      d = this.check(d)
      h = this.check(h)
      m = this.check(m)
      s = this.check(s)
      var timestr = y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s
      this.systemTime = timestr
      this.time = new Date(myDate.getTime() + 1000)
    },
    check(i) {
      var num = i < 10 ? '0' + i : i
      return num
    },
    exitAccount() {
      this.$confirm('Are you sure to exit?', 'Notice', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        customClass: 'confirm-message'
      })
        .then(async () => {
          const loading = this.$loading({
            lock: true,
            text: '退出登录',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          try {
            await this.$api.logout(2)
            removeToken()
            removeUserType()
            removeUserName()
            removeTeacherInfo()
            removeUserId()
            removeFirstSign()
            mutations.setHasRoute(false)
            resetRouter()
            loading.close()
            this.$router.push({ name: 'Login' })
          } catch (e) {
            loading.close()
          }
        })
        .catch()
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/global-components/NavHead/index.vue